import styled from "styled-components";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";

const PAYMENT_ICON_WIDTH = 36;
const PAYMENT_ICON_HEIGHT = 24;

export const Container = styled.div(() => ({
    display: "flex",
    alignItems: "center",
}));

export const PaymentMethod = styled.div<{ $isDisabled: boolean }>(({ theme, $isDisabled }) => ({
    padding: "18px 16px",
    position: "relative",
    overflow: "hidden",
    transform: "translateZ(0)",
    opacity: $isDisabled ? 0.7 : 1,

    "&::after": {
        content: '""',
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        borderTop: `1px dashed ${theme.colors[theme.colorMode].border_Secondary}`,
    },

    "&:last-child::after": {
        display: "none",
    },
}));

export const IconContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "flex-start",
    width: `${PAYMENT_ICON_WIDTH}px`,
    height: `${PAYMENT_ICON_HEIGHT}px`,
    borderRadius: "6px",
    border: `1px solid ${theme.colors[theme.colorMode].border_Secondary}`,
}));

export const Icon = styled(GenericIcon)<{
    $isDisabled: boolean;
}>(({ $isDisabled }) => ({
    filter: $isDisabled ? "grayscale(100%)" : "none",
    position: "relative",
}));

export const AlertMessage = styled.div(() => ({
    marginTop: "9px",
}));
